"use client";
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bulma/css/bulma.css';
import './assets/css/styles.login.css';
import axios from 'axios';
import App from './App';
import { registerLicense } from '@syncfusion/ej2-base';
//import ErrorBoundary from './components/ErrorBoundary.js';
//import { SocketProvider } from './hook/SocketIoHook';



registerLicense('ORg4AjUWIQA/Gnt2UlhhQlVMfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX9TdkdiWH5WcXBRQWBc');
axios.defaults.withCredentials = true;

//  if ('serviceWorker' in navigator) {
//         navigator.serviceWorker.register('/firebase-messaging-sw.js')
//             .then((registration) => {
//                 console.log('Service Worker registered with scope:', registration.scope);
//             })
//             .catch((error) => {
//                 console.error('Service Worker registration failed:', error);
//             });
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <SocketProvider>
  
  <App />
 
  // </SocketProvider>
  // <React.StrictMode>
  
  // </React.StrictMode>
);

